import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.main`
  position: relative;
  padding-top: ${(props) => props.theme.layout.chat_header_height};
  padding-bottom: 50px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 24px;
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.text.body16_medium};
  `}
`;

export const AccessibilityWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: 1px solid var(--background-divider, rgba(255, 255, 255, 0.2));
  border-radius: 23px;
  gap: 4px;
`;

export const AccessibilityButton = styled.button<{ selected: boolean }>`
  ${({ theme, selected }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 8px 0;
    border: 1px solid ${theme.backgroundColor.divider};
    border-radius: 19px;
    gap: 8px;
    color: ${theme.content.hierarchy3};
    ${theme.fontStyle.text.body16_bold};

    ${selected &&
    css`
      background: #fff;
      color: ${theme.content.hierarchy2_reverse};
    `}
  `}
`;

export const ParticipantsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.content_light_2};
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    ${theme.fontStyle.text.body16_medium};
  `}
`;

export const ButtonWrapper = styled.div`
  padding: 8px;
`;

export const SectionTitle = styled.h2`
  color: ${(props) => props.theme.content.hierarchy1};
  ${(props) => props.theme.fontStyle.text.body18_bold};
`;

export const NoItemMessage = styled.p`
  color: ${(props) => props.theme.content.hierarchy3};
  ${(props) => props.theme.fontStyle.text.body14_medium};
`;

export const DoneButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  padding: 8px 16px;
  transform: translateX(-50%);
`;
